<template>
  <img class="riclothes-logo" src="../assets/logo/logo_empty.svg" :class="{ dark: this.$root.config.isDarkTheme}">
</template>

<script>
export default {
  name: "ri-clothes-logo"
}
</script>

<style lang="scss" scoped>
.riclothes-logo {
  --logo-url: url("../assets/logo/logo_light.svg");

  background-repeat: no-repeat;
  background-image: var(--logo-url);
}

.dark {
  --logo-url: url("../assets/logo/logo_dark.svg");
}
</style>